import MainLayout from './mainLayout';

import AuthLayout from './authLayout';

export { MainLayout, AuthLayout };



// WEBPACK FOOTER //
// ./src/components/layout/index.js